import React from "react";
import { Trans } from "@lingui/react/macro";
import { formatDistanceToNow } from "date-fns";
import { Hourglass } from "lucide-react";
import { useLanguageStore } from "../../stores/languageStore.ts";

interface ChangeRequestExpiryProps {
  /** ISO instant string from the change request's `autoCancelAt`, or null. */
  autoCancelAt: string | null;
  /** Extra classes for color/spacing in the surrounding theme. */
  className?: string;
}

/**
 * Shows when a pending change request will be automatically cancelled if no one responds.
 * Renders nothing when there is no deadline (i.e. the request is no longer pending).
 */
const ChangeRequestExpiry: React.FC<ChangeRequestExpiryProps> = ({
  autoCancelAt,
  className,
}) => {
  const { dateFnsLocale } = useLanguageStore();

  if (!autoCancelAt) {
    return null;
  }

  const relative = formatDistanceToNow(new Date(autoCancelAt), {
    addSuffix: true,
    locale: dateFnsLocale,
  });

  return (
    <div
      className={`inline-flex items-center gap-1.5 text-xs ${className ?? ""}`}
    >
      <Hourglass className="h-3.5 w-3.5 shrink-0" />
      <span>
        <Trans>Auto-cancels if no response {relative}</Trans>
      </span>
    </div>
  );
};

export default ChangeRequestExpiry;
